import { Container, Typography } from '@pwskills/rachnaui';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { addToGoogleCalender } from '@/utils/masterclass/masterclass';
import MasterclassHeader from '../MasterclassHeader';

const JoinMasterClassSection = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );

  const { qrCodeImg, title, masterclassTimings, masterclassId, slug } = masterclassDetails;
  const JoinMasterclass = [
    {
      title: 'Study More',
      icon: '/images/masterclassDescription/join-masterclass/study-more.svg',
      description: 'Prepare for success with free study materials and notes ahead of the event.',
    },
    {
      title: 'Scan Link',
      icon: '/images/masterclassDescription/join-masterclass/scan-link.svg',
      description:
        'Secure your spot with the event joining link to stay informed about all the details.',
    },
    {
      title: 'Get Certified',
      icon: '/images/masterclassDescription/join-masterclass/certified.svg',
      description:
        'Afterwards, get your hands on a shareable certificate to proudly display your newfound skills!',
    },
    {
      title: 'No Spamming',
      icon: '/images/masterclassDescription/join-masterclass/spam.svg',
      description:
        'Secure your spot with the event joining link to stay informed about all the details.',
    },
  ];

  const triggerAddToCalendar = () => {
    const link = addToGoogleCalender(slug, masterclassId, title, masterclassTimings);
    window.open(link, '_new');
  };
  return (
    <div className="bg-blue-50 large:!bg-white">
      <Container
        id="category-hero-section"
        className="!py-8 medium:!pt-14 medium:!pb-8 large:!pt-[160px] large:!pb-20 flex flex-col !px-8 large:!px-20 "
      >
        <div className="flex flex-col  medium:flex-row gap-3  medium:gap-[52px]  large:justify-between">
          <div className="flex flex-col gap-3 medium:!gap-[52px] large:w-[628px]">
            <MasterclassHeader
              headerText="Join Our Masterclass Group"
              className=" text-start medium:text-left"
            />
            <div className="flex flex-wrap  gap-3 large:gap-6">
              {JoinMasterclass.map((item) => {
                return (
                  <div className="flex flex-col medium:flex-row gap-3 large:w-[302px]">
                    <img src={item.icon} alt={`${item.title}_image`} className="!w-6 !h-6" />
                    <div className="flex flex-col gap-2">
                      <Typography
                        component="body-regular"
                        variant="bold"
                        className="!text-[18px] !leading-[26px] medium:!text-[16px] medium:!leading-6"
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        component="body-tiny"
                        variant="semi-bold"
                        className="!text-[16px] !leading-[24px] medium:!text-[12px] medium:!leading-[18px] text-gray-650"
                      >
                        {item.description}
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex flex-col gap-3 medium:!min-w-[193px] justify-center items-center">
            <div className="flex flex-col gap-2 justify-center items-center">
              <div className="bg-blue-50 rounded-lg p-6">
                <img src={qrCodeImg} alt="qr code" className="w-[145px] min-h-[140px]" />
              </div>
              <Typography
                variant="semi-bold"
                component="body-tiny"
                className=" text-linkBlue !text-[12px] !leading-[18px]"
              >
                Scan to join group
              </Typography>
              <Typography
                variant="bold"
                component="body-tiny"
                className="!text-[10px] !leading-[16px]"
              >
                OR
              </Typography>
            </div>
            <div
              className="flex gap-1 py-2 px-3 rounded justify-center items-center border border-stroke-300 w-fit cursor-pointer"
              onClick={triggerAddToCalendar}
            >
              <Typography
                component="body-tiny"
                variant="semi-bold"
                className="!text-[12px] !leading-[18px]"
              >
                Add To Calendar
              </Typography>
              <img
                src="/images/masterclassDescription/join-masterclass/google-calendar.svg"
                alt="calendar-icon"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default JoinMasterClassSection;
